import { BaseService } from './base-service';
import { eventBus } from '@ahoy/aquarium/dist/core/EventBus';
import { Events } from '@ahoy/aquarium/dist/events/app-events';

type Deps = {};

export interface  ImageInfo {
  ID: number;
  id: number;
  title: string;
  filename: string;
  filesize: number;
  url: string;
  link: string;
  alt: string;
  author: string;
  description: string;
  caption: string;
  name: string;
  status: string;
  uploaded_to: number;
  date: string;
  modified: string;
  menu_order: number;
  mime_type: string;
  type: string;
  subtype: string;
  icon: string;
  width: number;
  height: number;
  sizes: {
    thumbnail: string;
    'thumbnail-width': number;
    'thumbnail-height': number;
    medium: string;
    'medium-width': number;
    'medium-height': number;
    medium_large: string;
    'medium_large-width': number;
    'medium_large-height': number;
    large: string;
    'large-width': number;
    'large-height': number;
    '1536x1536': string;
    '1536x1536-width': number;
    '1536x1536-height': number;
    '2048x2048': string;
    '2048x2048-width': number;
    '2048x2048-height': number;
    'home-resources': string;
    'home-resources-width': number;
    'home-resources-height': number;
    'post-resources': string;
    'post-resources-width': number;
    'post-resources-height': number;
  };
}

export interface WordpressLandingPageData {
    type: string;
    id: number;
    name: string;
    page_title: string;
    page_subtitle: string;
    button_text: string;
    image_desktop: string;
    image_mobile: string;
    logo_image_desktop: ImageInfo;
    logo_image_mobile: ImageInfo;
    text_max_width_column: string;
}


export class LandingPageService extends BaseService<Deps> {
  static serviceName: string = 'landingPageService';

  data?: WordpressLandingPageData;

  constructor() {
    super();

    eventBus().on(Events.Type.CustomLpLoad, (data) => {
      this.data = data;
    });
  }

}

LandingPageService.define();